const TOKEN_NAME = 'token';

export function setAuthToken(token, rememberMe = true) {
  localStorage.removeItem('token_session');
  if (rememberMe === false) {
    localStorage.setItem('token_session', true);
  }

  localStorage.setItem(TOKEN_NAME, JSON.stringify(token));
}

export function removeAuthToken() {
  localStorage.removeItem(TOKEN_NAME);
}

export function getAuthToken() {
  if (JSON.parse(localStorage.getItem('token_session')) === true) {
    removeAuthToken();
  }
  return JSON.parse(localStorage.getItem(TOKEN_NAME));
}



// WEBPACK FOOTER //
// ./src/containers/Auth/token.js